<template>
  <div>
    <div class="check">
      <h3>请确认信息</h3>
      <div class="address">
        <div class="add-left">
          <h4>请确认物流信息</h4>
          <div class="info">
            <div class="profile">
              <p><span>姓名</span>：{{ userProfile.nickName }}</p>
              <p><span>手机号码</span>：{{ userProfile.phone }}</p>
              <p><span>收货地址</span>：{{ userProfile.address }}</p>
            </div>
            <div class="btn">
              <el-button
                @click="infoVisible = true"
                v-if="userProfile.address"
                type="primary"
                plain
                >修改信息</el-button
              >
              <el-button @click="infoVisible = true" v-else type="primary" plain
                >补充信息</el-button
              >
            </div>
          </div>
        </div>
        <div class="add-right">
          <h4>请确认发票信息</h4>
          <div class="info" v-if="userProfile.ticketCode">
            <div class="profile">
              <p><span>姓名</span>：{{ userProfile.ticketName }}</p>
              <p><span>纳税人识别号</span>：{{ userProfile.ticketCode }}</p>
              <p><span>开票地址</span>：{{ userProfile.ticketAddress }}</p>
              <p><span>开户行及账号</span>：{{ userProfile.ticketBank }}</p>
            </div>
            <div class="btn">
              <el-button
                @click="ticketVisible = true"
                v-if="userProfile.ticketCode"
                type="primary"
                plain
                >修改信息</el-button
              >
              <el-button
                @click="ticketVisible = true"
                v-else
                type="primary"
                plain
                >补充信息</el-button
              >
            </div>
          </div>
          <div class="ticket-info" v-else>
            <el-radio-group v-model="radio" @change="needTicket">
              <el-radio :label="false" border>我不需要发票</el-radio>
              <el-radio :label="true" border>我需要发票</el-radio>
            </el-radio-group>
          </div>
        </div>
      </div>
    </div>
    <!-- 修改个人信息 -->
    <el-dialog v-model="infoVisible" title="补充/修改信息" width="500">
      <div class="form">
        <el-form :model="form" label-width="auto" style="max-width: 600px">
          <el-form-item label="收货人">
            <el-input v-model="form.nickName" />
          </el-form-item>
          <el-form-item label="手机号码">
            <el-input disabled v-model="form.phone" />
          </el-form-item>
          <el-form-item label="收货地址">
            <el-input v-model="form.address" />
          </el-form-item>
        </el-form>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="infoVisible = false">取消</el-button>
          <el-button type="primary" @click="infoSubmit"> 确认 </el-button>
        </div>
      </template>
    </el-dialog>
    <!-- 补充发票信息 -->
    <el-dialog
      :before-close="ticketCancel"
      v-model="ticketVisible"
      title="添加/修改开票信息"
      width="500"
    >
      <div class="form">
        <el-form :model="form" label-width="auto" style="max-width: 600px">
          <el-form-item label="名称" required>
            <el-input
              v-model="form.ticketName"
              placeholder="个人姓名/公司名称"
            />
          </el-form-item>
          <el-form-item label="纳税人识别号" required>
            <el-input
              v-model="form.ticketCode"
              placeholder="个人身份证/公司营业执照代码"
            />
          </el-form-item>
          <el-form-item label="地址、电话">
            <el-input
              v-model="form.ticketAddress"
              placeholder="个人住址/公司营业地址，个人票可不提供"
            />
          </el-form-item>
          <el-form-item label="开户行及账号">
            <el-input
              v-model="form.ticketBank"
              placeholder="开户行及开户行账户，个人票可不提供"
            />
          </el-form-item>
        </el-form>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="ticketCancel">取消</el-button>
          <el-button type="primary" @click="ticketSubmit"> 确认 </el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ElMessage } from "element-plus";
import { reactive, computed, ref } from "vue";
import { useStore } from "vuex";
import { getInfoUpdate, upInfoUpdate, postUserTicket } from "@/api/user";
export default {
  setup() {
    const store = useStore();
    const userProfile = ref([]);
    const ticket = ref([]);
    const infoVisible = ref(false);
    const radio = ref(false);
    const ticketVisible = ref(false);

    //计算并获取登录后用户信息数据
    const profile = computed(() => {
      return store.state.user.profile;
    });
    const form = reactive({
      nickName: "",
      phone: "",
      address: "",
      ticketName: "",
      ticketCode: "",
      ticketAddress: "",
      ticketBank: "",
    });

    //获取修改用户信息
    getInfoUpdate({ id: profile.value._id })
      .then((data) => {
        userProfile.value = data[0];
        form.nickName = data[0].nickName;
        form.phone = data[0].phone;
        form.address = data[0].address;
        form.ticketName = data[0].ticketName;
        form.ticketCode = data[0].ticketCode;
        form.ticketAddress = data[0].ticketAddress;
        form.ticketBank = data[0].ticketBank;
      })
      .catch((error) => {
        console.log(error);
      });
    const InfoUpdate = () => {
      try {
        infoVisible.value = true;
      } catch (error) {
        console.log(error);
      }
    };
    const infoSubmit = () => {
      upInfoUpdate({
        nickName: form.nickName,
        phone: form.phone,
        address: form.address,
        id: profile.value._id,
      })
        .then((data) => {
          if (data.code == 201) {
            ElMessage({
              message: data.msg,
              type: "success",
            });
            infoVisible.value = false;
            getInfoUpdate({ id: profile.value._id }).then((data) => {
              userProfile.value = data;
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    };

    const needTicket = (ele) => {
      try {
        if (ele == !false) {
          ticketVisible.value = !ticketVisible.value;
        }
      } catch (error) {
        console.log(error);
      }
    };

    /*  const ticketClose = () => {
      ticketVisible.value = false;
      radio.value = false;
    }; */
    const ticketCancel = () => {
      try {
        ticketVisible.value = false;
        radio.value = false;
      } catch (error) {
        console.log(error);
      }
    };

    const ticketSubmit = () => {
      //向后台提交发票信息
      postUserTicket({
        id: profile.value._id,
        ticketName: form.ticketName,
        ticketCode: form.ticketCode,
        ticketAddress: form.ticketAddress,
        ticketBank: form.ticketBank,
      })
        .then((data) => {
          if (data.code == 200) {
            ElMessage({
              message: data.msg,
              type: "success",
            });
            ticketVisible.value = false;
            getInfoUpdate({ id: profile.value._id }).then((data) => {
              userProfile.value = data;
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    };
    return {
      form,
      infoSubmit,
      profile,
      infoVisible,
      ticketVisible,
      ticketCancel,
      InfoUpdate,
      radio,
      ticket,
      userProfile,
      needTicket,
      ticketSubmit,
    };
  },
};
</script>

<style lang="less" scoped>
.check {
  width: 1240px;
  margin: 0 auto;

  h3 {
    margin-top: 15px;
  }
  .address {
    display: flex;
    justify-content: space-between;
    .add-left {
      margin-top: 15px;
      width: 600px;
      height: 200px;
      background: #fefefe;
      border-radius: 8px;
      h4 {
        margin-top: 8px;
        text-align: center;
      }
      .info {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 150px;
        .profile {
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: space-evenly;
          margin-left: 15px;
          span {
            display: inline-block;
            font-weight: bold;
            width: 70px;
            text-align-last: justify;
          }
        }
        .btn {
          margin-right: 25px;
        }
      }
    }
    .add-right {
      margin-top: 15px;
      width: 600px;
      height: 200px;
      background: #fefefe;
      border-radius: 8px;
      h4 {
        margin-top: 8px;
        text-align: center;
      }
      .info {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 150px;
        .profile {
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: space-evenly;
          margin-left: 10px;
          span {
            display: inline-block;
            font-weight: bold;
            width: 85px;
            text-align-last: justify;
          }
        }
        .btn {
          margin-right: 15px;
        }
      }
      .ticket-info {
        text-align: center;
        line-height: 125px;
      }
    }
  }
}
</style>
